import { render, staticRenderFns } from "./MenuParcerias.vue?vue&type=template&id=2e0bf46b&scoped=true"
import script from "./MenuParcerias.vue?vue&type=script&lang=js"
export * from "./MenuParcerias.vue?vue&type=script&lang=js"
import style0 from "./MenuParcerias.vue?vue&type=style&index=0&id=2e0bf46b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0bf46b",
  null
  
)

export default component.exports